import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UserPrivilegeService} from '../../../../services/common/user-privilege/user-privilege.service';
import {NodeDialogInf} from '../../../nodes/nodes-dialog/nodes-dialog.component';

@Component({
  selector: 'add-offline-node-dialog',
  templateUrl: './add-offline-node-dialog.component.html',
  styleUrls: ['./add-offline-node-dialog.component.scss']
})
export class AddOfflineNodeDialogComponent implements OnInit {

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  isAuthorized: boolean;

  constructor(public dialogRef: MatDialogRef<NodeDialogInf>,
              @Inject(MAT_DIALOG_DATA) public data: NodeDialogInf,
              private userPrivilege: UserPrivilegeService) {
  }

  ngOnInit(): void {
    this.isAuthorized = this.userPrivilege.isAuthorized();
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    if (!this.data.isEditMode) {
      // this.updateAddressProperty(this.data.selectedItem);
    }
    this.onApply.emit(this.data);
  }
}
